/* French locals for flatpickr */
var Flatpickr = Flatpickr || { l10ns: {} };
Flatpickr.l10ns.fr = {};

Flatpickr.l10ns.fr.firstDayOfWeek = 1;

Flatpickr.l10ns.fr.weekdays = {
	shorthand: ['Dim', 'Lun', 'Mar', 'Mer', 'Jeu', 'Ven', 'Sam'],
	longhand: ['Dimanche', 'Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi']
};

Flatpickr.l10ns.fr.months = {
	shorthand: ['Janv', 'Févr', 'Mars', 'Avr', 'Mai', 'Juin', 'Juil', 'Août', 'Sept', 'Oct', 'Nov', 'Déc'],
	longhand: ['Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre']
};

Flatpickr.l10ns.fr.ordinal = function (nth) {
	if (nth > 1) {
		return "ème";
	}

	return "er";
};
if (typeof module !== "undefined") {
	module.exports = Flatpickr.l10ns;
}


//////////////////
// WEBPACK FOOTER
// ./~/flatpickr/dist/l10n/fr.js
// module id = 13
// module chunks = 0